document.addEventListener('DOMContentLoaded', function () {
  var nav = document.querySelector('nav.collection__nav');
  if (!nav) return;

  var headerWrapper = document.querySelector('[data-header-wrapper]');
  var headerEl = headerWrapper ? headerWrapper.querySelector('[data-header-height]') : null;
  var sidebarSlider = document.querySelector('[data-collection-sidebar]');
  var productsContainer = document.getElementById('collection-products');

  // Spacer holds the nav's document-flow space when nav goes fixed
  var spacer = document.createElement('div');
  spacer.setAttribute('aria-hidden', 'true');
  spacer.style.cssText = 'display:none;';
  nav.insertAdjacentElement('afterend', spacer);

  var isSticky = false;
  var naturalOffsetTop = 0;
  var SIDEBAR_WIDTH = 270; // matches CSS min-width on expanded slider

  function getHeaderBottom() {
    if (!headerWrapper || !headerWrapper.classList.contains('js__header__stuck')) return 0;
    var el = headerEl || headerWrapper;
    return Math.max(0, el.getBoundingClientRect().bottom);
  }

  function getNavBottom() {
    // nav.getBoundingClientRect().bottom is accurate because nav is position:fixed
    return isSticky ? Math.max(0, nav.getBoundingClientRect().bottom) : 0;
  }

  function isSidebarExpanded() {
    return sidebarSlider && sidebarSlider.classList.contains('expanded');
  }

  function isDesktop() {
    return window.innerWidth >= 750;
  }

  function measure() {
    var wasSticky = isSticky;
    if (wasSticky) {
      nav.classList.remove('sticky');
      spacer.style.display = 'none';
    }
    naturalOffsetTop = nav.getBoundingClientRect().top + window.scrollY;
    spacer.style.height = nav.offsetHeight + 'px';
    if (wasSticky) {
      nav.classList.add('sticky');
      spacer.style.display = 'block';
    }
  }

  // ── Sidebar fixed positioning ──────────────────────────────────────────────

  function fixSidebar() {
    if (!sidebarSlider || !productsContainer) return;
    var top = getNavBottom();
    sidebarSlider.style.position = 'fixed';
    sidebarSlider.style.left    = '0';
    sidebarSlider.style.top     = top + 'px';
    sidebarSlider.style.height  = 'calc(100vh - ' + top + 'px)';
    sidebarSlider.style.width   = SIDEBAR_WIDTH + 'px';
    sidebarSlider.style.zIndex  = '90';
    // Reserve the sidebar space so products don't slide under it
    productsContainer.style.paddingLeft = SIDEBAR_WIDTH + 'px';
  }

  function resetSidebar() {
    if (!sidebarSlider || !productsContainer) return;
    sidebarSlider.style.cssText = '';
    productsContainer.style.paddingLeft = '';
  }

  function syncSidebar() {
    if (isSticky && isSidebarExpanded() && isDesktop()) {
      fixSidebar();
    } else {
      resetSidebar();
    }
  }

  function updateSidebarTop() {
    if (!isSticky || !isSidebarExpanded() || !sidebarSlider) return;
    var top = getNavBottom();
    sidebarSlider.style.top    = top + 'px';
    sidebarSlider.style.height = 'calc(100vh - ' + top + 'px)';
  }

  // ── Nav sticky ─────────────────────────────────────────────────────────────

  function stick() {
    isSticky = true;
    nav.style.top = getHeaderBottom() + 'px';
    nav.classList.add('sticky');
    spacer.style.display = 'block';
    document.documentElement.style.setProperty('--collection-nav-height', nav.offsetHeight + 'px');
    syncSidebar();
  }

  function unstick() {
    isSticky = false;
    nav.classList.remove('sticky');
    nav.style.top = '';
    spacer.style.display = 'none';
    document.documentElement.style.setProperty('--collection-nav-height', '0px');
    resetSidebar();
  }

  function onScroll() {
    var headerBottom = getHeaderBottom();
    var shouldStick  = window.scrollY + headerBottom > naturalOffsetTop;

    if (shouldStick && !isSticky) {
      stick();
    } else if (!shouldStick && isSticky) {
      unstick();
    } else if (isSticky) {
      // Keep nav top in sync (e.g. announcement bar dismissed)
      nav.style.top = headerBottom + 'px';
      updateSidebarTop();
    }
  }

  // Watch for the sidebar being opened or closed while nav is already sticky
  if (sidebarSlider) {
    new MutationObserver(function () {
      syncSidebar();
    }).observe(sidebarSlider, { attributes: true, attributeFilter: ['class'] });
  }

  document.addEventListener('theme:scroll', onScroll);

  window.addEventListener('resize', function () {
    measure();
    onScroll();
  });

  measure();
  onScroll();
});
